import { Outlet, createFileRoute, notFound } from '@tanstack/react-router'

import { StudentAppNavigationTabsDiscover } from '@/app/student/StudentAppNavigationTabsDiscover'
import { FEATURE_DISCOVER } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import DashboardPage from '@/dashboard/components/DashboardPage/DashboardPage'

export const Route = createFileRoute('/_learning/discover')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-discover',
        }),
      },
    ],
  }),
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_DISCOVER)) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <StudentAppNavigationTabsDiscover>
      <DashboardPage>
        <Outlet />
      </DashboardPage>
    </StudentAppNavigationTabsDiscover>
  )
}
